import { createSession } from '@/app/lib/sessions'
import localStorage from '@/src/local-storage'

export async function impersonate(token, userId) {
  const url = new URL(`${process.env.API}/login`)
  url.search = new URLSearchParams({ userId }).toString()
  const getConfig = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token // this route with userId will only work for admins in db
    }
  }
  try {
    const res = await fetch(url, getConfig)
    if (!res.ok) {
      throw new Error('Failed to fetch impersonatated user')
    }
    const d = await res.json()
    await createSession(d.token, d.meta?.ember)
    localStorage.setUser(d)
    return d
  } catch (err) {
    console.error(err)
    throw new Error('Failed to fetch impersonatated user')
  }
}